import styles from "./List.module.css";

function Pagination({ pagination, onPageChange, isLoading = false }) {
  if (!pagination || pagination.lastPage <= 1) return null;

  return (
    <nav className={styles.pagination} aria-label="Pagination">
      <button
        type="button"
        className={styles.paginationButton}
        onClick={() => onPageChange(pagination.page - 1)}
        disabled={!pagination.hasPreviousPage || isLoading}
      >
        Previous
      </button>
      <span className={styles.paginationInfo} aria-live="polite">
        Page {pagination.page} of {pagination.lastPage}
      </span>
      <button
        type="button"
        className={styles.paginationButton}
        onClick={() => onPageChange(pagination.page + 1)}
        disabled={!pagination.hasNextPage || isLoading}
      >
        Next
      </button>
    </nav>
  );
}

export default Pagination;
